import { AfterViewInit, Component, HostListener, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { StorageKeys } from "@core";
import { pageRoutes } from "src/app/core/config/page-routes.config";
import { StorageService } from "src/app/core/services/storage/storage.service";
import { ExamCountrySetupComponent } from "src/app/shared/helpers/global/exam-country-setup/exam-country-setup.component";
@Component({
    selector: "app-share",
    templateUrl: "./share.component.html",
    styleUrls: ["./share.component.less"],
    standalone: false
})
export class ShareComponent implements OnInit, AfterViewInit {
  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.checkScreenSize();
  }

  @ViewChild(ExamCountrySetupComponent) examCountrySetup!: ExamCountrySetupComponent;


  examCountrySetupModal: boolean = false;
  user: any;

  isSmallScreen: boolean = false;
  routeMatch: boolean = false;


  constructor(
    private storageSrv: StorageService,
    private router: Router,
  ) { 
    this.user = JSON.parse(localStorage.getItem(StorageKeys.TOKEN)!)
    // this.routeMatch = this.router.url.includes(pageRoutes.access.shareHistory);
  }

  ngOnInit(): void { 
    this.checkScreenSize();
  }

  ngAfterViewInit(): void {
    this.checkScreenSize();
  }

  onClick() {
    this.storageSrv.setCertificateShareContentID('shareHistory')
  }

 get checkRoute() {
    const url = this.router.routerState.snapshot.url.includes(pageRoutes.access.shareHistory);
    return url
  }
  


  checkScreenSize() {
    if (window.screen.width < 480) { 
      this.isSmallScreen = true;
      return
    }

    this.isSmallScreen = false;
  }

  closeExamCountrySetupModal() {
    this.examCountrySetup?.modalRef?.close();  
  }

}
